import Form from 'forms/_.extend';

export const makeFields: Function = t => {
  const fields = ['search', 'search.input'];

  const labels = {
    search: `${t('general:actions.search')}...`,
    'search.input': `${t('general:actions.search')}...`,
  };

  return { fields, labels };
};

class ModalSearchForm extends Form {}

export const createModalSearchForm = (fieldOptions: Array<*>) => {
  const { labels, fields, rules, extra } = fieldOptions;
  return new ModalSearchForm({ labels, fields, rules, extra });
};
